import { createCrudHooks } from "../common/queries";

export const holidayApi = createCrudHooks({
	baseKey: "holidays",
	basePath: "/holidays",
});
